/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrencyModel } from '../../models/currency-model';
import { GetCurrencyBaseRequest } from '../../models/get-currency-base-request';

export interface PostApiCurrencyV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request object containing filter and sorting options for currencies.
     */
    body?: GetCurrencyBaseRequest
}

export function postApiCurrencyV1$Json(http: HttpClient, rootUrl: string, params?: PostApiCurrencyV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
  const rb = new RequestBuilder(rootUrl, postApiCurrencyV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CurrencyModel>>;
    })
  );
}

postApiCurrencyV1$Json.PATH = '/private/v1/currencies';
